import type { IProduct, ISubscription } from '@wegic/price-ui';
import { filterPricingProducts } from '@wegic/price-ui';
import { resolvePricingMultiYearPageDecision } from '@/experiments/pricingMultiYearPage';

export async function filterPricingProductsForSubscription(
  products: IProduct[],
  userSubscription?: ISubscription | null,
): Promise<IProduct[]> {
  if (userSubscription?.exist !== false) {
    return filterPricingProducts(products, 'multi-year');
  }

  const decision = await resolvePricingMultiYearPageDecision();
  return filterPricingProducts(products, decision.experience.planSelectionMode);
}
